const url = `${process.env.REACT_APP_API_URL}/synthetic-data/`

export function requestSyntheticData(data) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json"},
        body: JSON.stringify(data)
    }
    return fetch(url, requestOptions).then(response => response.json())
}

export function requestDataDownload(id) {
    const requestUrl = `${url}?id=${id}`
    window.open(requestUrl, "_blank")
}
